import { render, staticRenderFns } from "./AddRedirectForm.vue?vue&type=template&id=05b4ff25&"
import script from "./AddRedirectForm.vue?vue&type=script&lang=js&"
export * from "./AddRedirectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05b4ff25')) {
      api.createRecord('05b4ff25', component.options)
    } else {
      api.reload('05b4ff25', component.options)
    }
    module.hot.accept("./AddRedirectForm.vue?vue&type=template&id=05b4ff25&", function () {
      api.rerender('05b4ff25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Domains/Redirects/AddRedirectForm.vue"
export default component.exports